// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
Rails.start();
window.Rails = Rails
require("@rails/activestorage").start()
require("channels")
require("jquery")
require('common/l_sidemenu_toggle')
require('common/viewport')

import '../stylesheets/application.scss'
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
// loads the Icon plugin
UIkit.use(Icons);
window.UIkit = UIkit;

import Highcharts from 'modules/highcharts';
import addMore from "highcharts/highcharts-more";
import addDumbbell from 'highcharts/modules/dumbbell';
import addBrokenAxis from 'highcharts/modules/broken-axis';
import addPareto from 'highcharts/modules/pareto';
import addTreemap from 'highcharts/modules/treemap.js'
addMore(Highcharts)
addDumbbell(Highcharts)
addBrokenAxis(Highcharts)
addPareto(Highcharts)
addTreemap(Highcharts)
window.Highcharts = Highcharts;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
